import sanity from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
import { getStoreLocation } from 'ck-utils';

export const sanityClient = sanity({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: '2021-03-25',
  useCdn: process.env.NODE_ENV === 'production',
});

const builder = imageUrlBuilder(sanityClient);

export const getSanityImg = (source) => builder.image(source).auto('format');

export const sanityToImgix = (sanityUrl) => (
  process.env.REACT_APP_SANITY_DATASET === 'production'
    ? sanityUrl?.replace(
        'cdn.sanity.io/images/0s84w0hq/production',
        'culture-kings-sanity.imgix.net'
      ).replace('auto=format', 'auto=compress,format')
    : sanityUrl
);

/**
 * Default to AU for Sanity if we are in dev stores for now since we don't have contents for each UAT/DEV store
 * @todo: considering having replicas between production and development dataset when we go with Sanity enterprise
 * @returns {string|string}
 */
export const getSanityRegion = () => {
  const storeLocation = getStoreLocation();
  return ['NZ', 'US', 'UK'].includes(storeLocation) ? storeLocation : 'AU';
};
